import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // NOTE: Replace with your actual Firebase config values
  apiKey: "AIzaSyDgSXOlLkZZ1yg282oQ2_6LVyCNU1JqHTg",
  authDomain: "translatorx-5774e.firebaseapp.com",
  projectId: "translatorx-5774e",
  storageBucket: "translatorx-5774e.firebasestorage.app",
  messagingSenderId: "868717168128",
  appId: "1:868717168128:web:6abf70277dc0e5c3a9fae5",
  measurementId: "G-LYKSTZKGF1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, "europe-west1");

export { app, auth, db, storage, functions };
